import {
	ChangeDetectionStrategy,
	Component,
	inject,
	input,
	output,
	signal,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { GenTableDisplayComponent } from "@app/gen-table-display/gen-table-display.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { ApiService, senderFactory } from "@app/services/api.service"
import { LangService } from "@app/services/lang.service"
import { ModalService } from "@app/services/modal.service"
import { StoreService } from "@app/services/store.service"
import { BtnExtComponent } from "@app/utils/utils.component"

@Component({
	selector: "invite-btn",
	imports: [
		COMMON_IMPORTS,
		BtnExtComponent,
		ModalWrapComponent,
		GenTableDisplayComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<app-btn-ext
			text="submit"
			[isSpin]="sender.isLoading()"
			(clickEv)="preSend()"
		/>
		@if (modalProps()) {
			<app-modal-wrap
				(onClose)="onClose.emit()"
				title="contactways"
				modalWrapperClass="modal-800"
			>
				<app-gen-table-display
					(onClose)="
						modalProps.set(null); $event?.length ? send($event) : onClose.emit()
					"
					tableName="contactways"
					[filterField]="type() + '_id'"
					[filterFieldValue]="id()"
					fieldNameInItemToDisplay="contactway"
					chooseOnlyOne
					[filterFieldOrs]="{ contactway_identifier: ['email', 'phone'] }"
				/>
			</app-modal-wrap>
		}
	`,
})
export class InviteBtn {
	type = input.required<string>()
	id = input.required<any>()
	version_id = input.required<any>()
	onClose = output()

	apiService = inject(ApiService)
	modalService = inject(ModalService)
	store = inject(StoreService)
	lang = inject(LangService)

	modalProps = signal<any>(null)

	sender = senderFactory({
		fn: ({ isWhatsapp, contactway }) =>
			this.apiService.post("invite_policy_form_one", {
				version_id: this.version_id(),
				person_id: this.id(),
				person_type: this.type(),
				is_wa: isWhatsapp,
				contactway_id: contactway?.id,
			}),
		onFinish: ({ result, params: { isWhatsapp, contactway } }) => {
			this.onClose.emit()
			if (isWhatsapp) {
				return this.openWhatsapp(result, contactway)
			}
			this.modalService.openToast("invitation_sent")
		},
	})

	async preSend() {
		if (this.type() !== "user") {
			this.modalProps.set({})
			return
		}
		this.send([])
	}

	async send(arr: any[]) {
		const isUser = this.type() === "user"
		const contactway = arr.at(0)
		const isWhatsapp = isUser ? false : contactway.isWhatsapp
		this.sender.run({ isWhatsapp, contactway })
	}
	openWhatsapp(res: any, contactway: any) {
		const waphone = contactway.contactway.substring(1)
		const person = this.store.getPerson(this.id(), this.type())
		const message_text = `${this.lang.getVal("hello")}
      ${person.name}
        %0A${this.lang.getVal("to_sign_and_fill")}
        %0A%0A   ${res}`

		window.open(this.store.getWhatsappUrl(waphone, message_text), "_blank")
		this.modalService.openToast("sent")
	}
}
